export default __webpack_public_path__ + "static/media/Ring.41d4d309.svg";